exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-d05840e8] .dropdown-menu {\n  margin-left: 0 !important;\n}\n.custom-margin-bottom[data-v-d05840e8] {\n  margin-bottom: 0;\n}\n.custom-toolbar .custom-toolbar-start[data-v-d05840e8] {\n  -webkit-box-flex: 3;\n      -ms-flex: 3;\n          flex: 3;\n}\n.table-bulk-action-container[data-v-d05840e8] {\n  top: -18px !important;\n  z-index: 1000;\n}\n.table-bulk-action-container .bulk-action-btn[data-v-d05840e8] {\n    width: 180px;\n}\n.body-list[data-v-d05840e8] {\n  max-height: 70vh;\n  overflow-y: auto;\n  margin-top: 20px;\n}\n[data-v-d05840e8] .tab-content {\n  margin-top: 0 !important;\n}\n", ""]);

// exports
